<template>
  <div class="text-left">
    <UlSelect
      :id="`dynamicInput-${inputData.id}`"
      v-model="$v.inputValue.$model"
      :error="$v.inputValue.$error"
      :error-messages="$v.inputValue.$error ? errorText : null"
      :hint="getLocaleText(inputData.help)"
      :label="addNbsp(getLocaleText(inputData.label))"
      :menu-props="{ contentClass: 'v-select__menu' }"
      :options="values"
      :placeholder="getLocaleText(inputData.help)"
      :valid="
        $v.inputValue.$dirty &&
        !$v.inputValue.$invalid &&
        ((!inputData.required && inputValue && inputValue.length) || inputData.required)
      "
      hide-details="auto"
      @input="updateValue"
    >
      <template #optionPrepend="{ item }">
        <v-list-item-icon v-if="item.helpPictureUrl" class="mr-2 my-0">
          <v-img max-width="150" contain :src="item.helpPictureUrl" />
        </v-list-item-icon>
      </template>
      <template #optionTitle="{ item }">
        {{ getLocaleText(item.value) }}
      </template>
      <template #selection="{ item }">
        {{ getLocaleText(item.value) }}
      </template>
    </UlSelect>
  </div>
</template>
<script>
import formGtm from '@/mixins/formGtm';
import sortableValues from '@/mixins/sortableValues';
import { required } from 'vuelidate/lib/validators';
export default {
  name: 'UlSelectDynamic',
  mixins: [formGtm, sortableValues],
  props: {
    errorText: {
      type: String,
      default: ''
    },
    inputData: {
      type: Object,
      required: true
    },
    store: {
      type: String,
      required: true
    },
    stepId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      inputValue: null
    };
  },
  validations() {
    if (this.inputData.required) {
      return {
        inputValue: { required }
      };
    }
    return { inputValue: {} };
  },
  computed: {
    responses() {
      return this.$store.getters['dynamicForms/responses'];
    },

    values() {
      let values = [...this.inputData.values];

      if (!this.inputData.sortValues) {
        if (this.inputData.inputValidation === 'pastyear') {
          let date = new Date();
          for (let iter = 0; iter < 30; iter++) {
            values.push({
              value: parseInt(date.getFullYear()) - iter,
              id: parseInt(date.getFullYear()) - iter
            });
          }
        }

        if (this.inputData.inputValidation === 'month') {
          for (let iter = 0; iter < 12; iter++) {
            let date = new Date(2009, iter, 10);
            let month = date.toLocaleString(this.$i18n.locale, { month: 'long' });
            values.push({
              value: this.capitalizeFirstLetter(month),
              id: iter
            });
          }
        }

        if (this.inputData.systemProperty.indexOf('health_insurance_provider_id') !== -1) {
          const csInsurance = values.filter(val => val.additionalInfo.countryCode === 'CZ');
          const skInsurance = values.filter(val => val.additionalInfo.countryCode === 'SK');

          values = this.$domainRegion === 'cz' ? values : skInsurance.concat(csInsurance);
        }

        return values;
      }

      return this.sortValues(values);
    }
  },
  created() {
    if (this.responses[this.formName][this.inputData.id]) {
      this.inputValue = +this.responses[this.formName][this.inputData.id];
    }
    this.$v.$reset();
    this.$eventHub.$on(`validateInput_${this.inputData.id}_${this.stepId}`, () => this.validate());
    this.$eventHub.$on(`resetValidationInput_${this.inputData.id}_${this.stepId}`, () =>
      this.reset()
    );

    if (this.inputValue) {
      this.updateValue(false);
    }
  },
  beforeDestroy() {
    this.$eventHub.$off(`validateInput_${this.inputData.id}_${this.stepId}`);
    this.$eventHub.$off(`resetValidationInput_${this.inputData.id}_${this.stepId}`);
  },
  methods: {
    reset() {
      this.$v.$reset();
    },
    validate() {
      this.$v.$touch();
      this.$store.commit('dynamicForms/updateValidation', {
        id: this.inputData.id,
        value: !this.$v.$invalid,
        formName: this.formName
      });
    },
    updateValue(emit = true) {
      this.validate();
      // this.sendGtmEvent(this.inputData.label)

      this.$store.dispatch('dynamicForms/updateResponse', {
        id: this.inputData.id,
        value: this.$v.inputValue.$model || null,
        formName: this.formName
      });
      if (emit) {
        this.$emit('update:value');
      }
    }
  }
};
</script>
